import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  WithStyles,
  createStyles,
  Button,
  Typography,
} from "@material-ui/core";
import { MyPATDialog } from "../../../common";
import Select from 'react-select';
import { VALIDATION_TYPE_CONSTANTS } from "../../../../constants/comman";
const styles = (theme: Theme) =>
  createStyles({
    root: {
		display: "flex",
		flexWrap: "wrap",
    },
    checkImage: {
    	margin: "30px auto 20px",
      	display: "block",
    },
	buttonContainer: {
		marginTop: "18px",
		marginBottom: "20px",
		display: "flex",
		justifyContent: "center",
    alignItems: "center",
    gap: '19px',
	},

  dropLists:{
		background:'#fff',
		padding:15,
		borderRadius:4,
		boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
		'& span':{
			display:'block',
			padding:'0 0 10px 0',
			cursor:'pointer',
			color:'#666',
			'&:hover':{
				color:'#1d7dea',
				'font-weight':'600',
			},
		},
	},
  basicSingle: {
		'width': '210px',
		'z-index': 2000,
		'margin-right': '20px',
		'& .validationSelect__control':{
			borderColor:'#1d7dea',
			'&:hover':{
				borderColor:'#1d7dea',
			},
			'& .css-tlfecz-indicatorContainer':{
				color:'#1d7dea',
			},
			'& .css-1okebmr-indicatorSeparator': {
				height: '100%',
				marginTop: 0,
				backgroundColor: '#1d7dea'
			},
			'& .css-1wa3eu0-placeholder':{
				color:'#1d7dea',
			},
		},
	},
  });


const colorStyles = {
  option: (styles: any) => {
    return {
      ...styles,
      cursor: 'pointer',
      backgroundColor: '#ffffff',
      ':hover': {
            ...styles[':hover'],
        backgroundColor: '#ffffff',
        color:'#1d7dea',
      }
    }
  },
  singleValue: (styles: any) => ({ ...styles,  color: '#1D7DEA' }),
  dropdownIndicator: (styles: any) => {
    return {
      ...styles,
      color: '#1D7DEA',
      ':hover':{
        ...styles['.hover'],
        color:'#1d7dea',
      }
    }
  }
}
interface Props extends WithStyles<typeof styles> {
  classes: any;
  bodyText: string;
  startNewValidation: Function;
}
interface States {
  validationSelection: any;
}

class ValidationSubmitModal extends Component<Props, States> {
  constructor(props: Props) {
    super(props);
    this.state = {
      validationSelection: null
    };
  }
  render() {
    const { classes, bodyText, startNewValidation } = this.props;
    return (
      <div>
        <MyPATDialog
          dialogOpen={true}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: "sm",
          }}
        >
          <img
            src="/assets/img/mylibrary/publish.png"
            className={classes.checkImage}
            alt="Tick"
          />
          <Typography variant="body2" align="center">
            Validation Completed
          </Typography>
          <Typography variant="caption" align="center">
            {bodyText}
          </Typography>
          <div className={classes.buttonContainer}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => window.close()}
            >
              Back to My Library
            </Button>
            <Select
              className={classes.basicSingle}
              classNamePrefix="validationSelect"
              name="validationType"
              options={VALIDATION_TYPE_CONSTANTS}
              isSearchable={false}
              isClearable={false}
              placeholder="Start New Validation"
              autoFocus={false}
              menuPlacement={'top'}
              value={this.state.validationSelection}
              onChange={(ev: any) => {
                  this.setState({
                    validationSelection: null
                  });
                 startNewValidation && startNewValidation(ev);
                }}
              styles={colorStyles}
            />
          </div>
        </MyPATDialog>
      </div>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(ValidationSubmitModal);
